(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/ticket-card.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/ticket-card.js');
"use strict";


const {
  Fragment,
  useContext
} = React;
const {
  Card
} = svs.ui.ReactCard;
const {
  trackTicketCard
} = svs.eInstant.tracking;
const {
  RibbonCorner
} = svs.ui.ReactRibbon;
const Badge = svs.ui.ReactBadge;
const {
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  ImageMemo
} = svs.eInstant.shared.components;
const TicketCard = _ref => {
  var _game$tags;
  let {
    ticketConfig: game,
    number = null,
    isNumberedList = false,
    className = ''
  } = _ref;
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const {
    dispatch
  } = useContext(svs.eInstant.store.RouterContext);
  const {
    GAME_URL
  } = svs.eInstant.store.actions;
  const validGame = svs.eInstant.util.validateGameConfig(game);
  if (!validGame) return null;
  const handleCardClick = event => {
    event.preventDefault();
    trackTicketCard(game.name);
    if (svs.core.detect.formfactor.mobile()) {
      const url = "".concat(game.infoUrl, "?returnUrl=").concat(pathname);
      history.push(url);
    } else {
      const basePath = window.location.pathname;
      const match = basePath.match(/^(.*?)\/info/);
      const basePathInfo = match ? match[1] : basePath;
      const newUrl = "".concat(basePathInfo.replace(/\/+$/, '')).concat(game.infoUrl);
      window.history.pushState(null, '', newUrl);
      dispatch({
        type: GAME_URL,
        payload: {
          gameUrl: game.url
        }
      });
    }
  };
  return React.createElement("div", {
    className: "u-position-relative w100"
  }, isNumberedList && number !== null && React.createElement("div", {
    className: "einstant-ticket-card-number-wrapper absolute"
  }, React.createElement(Badge, {
    className: "einstant-ticket-card-number w100 h100 u-flex u-flex-align-items-center u-flex-justify-content-center"
  }, React.createElement("h1", {
    className: "h1 margin-0"
  }, number))), React.createElement(Card, {
    "aria-label": "".concat(game.name, ". Insats: ").concat(game.maxPrice ? "".concat(game.minPrice, " - ").concat(game.maxPrice, " kr") : "".concat(game.minPrice, " kr"), ". Maxvinst: ").concat(svs.utils.format.Currency(game.maxWin), " kr."),
    className: "f-body u-position-relative clip ".concat(className, " einstant-ticket-card"),
    Component: "a",
    href: "#",
    onClick: handleCardClick
  }, React.createElement(Fragment, null, React.createElement("div", {
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center u-flex-justify-content-center relative einstant-ticket-card-background"
  }, React.createElement(ImageMemo, {
    fitWrapper: true,
    image: game.imageBackground,
    loadingLazy: true
  }), game.logotype && React.createElement(ImageMemo, {
    cssSelectors: "padding-half einstant-ticket-card-logo",
    fitWrapper: true,
    image: game.logotype,
    loadingLazy: true
  })), game.badge && React.createElement("div", {
    className: "tickets-einstant-ribbon-theme"
  }, React.createElement(RibbonCorner, {
    size: 500
  }, game.badge)), React.createElement("div", {
    className: "einstant-ticket-card-body relative u-flex u-flex-column padding-h-1 u-flex-align-items-center bg-fler-lotter-new-500"
  }, React.createElement("h3", {
    className: "h3 align-center fc-fler-lotter-new-300 einstant-tickets-card-title margin-bottom-0 u-overflow-threedots u-text-center w100"
  }, game.name), React.createElement("div", {
    className: "fc-fler-lotter-new-300 einstant-ticket-card-tag"
  }, ((_game$tags = game.tags) === null || _game$tags === void 0 ? void 0 : _game$tags.length) > 0 && React.createElement("span", {
    className: "f-400 u-block"
  }, game.tags[0])), React.createElement("div", {
    className: "w100 tickets-einstant-short-description"
  }, React.createElement("p", {
    className: "p align-center fc-fler-lotter-new-400"
  }, game.shortDescription)), React.createElement("div", {
    className: "u-bottom-0 absolute w100"
  }, React.createElement("div", {
    className: "u-flex u-flex-row padding-h-1 padding-v-1"
  }, React.createElement("p", {
    className: "p f-bold fc-fler-lotter-new-300 margin-bottom-0"
  }, game.maxPrice ? "".concat(game.minPrice, " - ").concat(game.maxPrice, " kr") : "".concat(game.minPrice, " kr")), React.createElement("p", {
    className: "p f-bold fc-fler-lotter-new-300 tickets-einstant-margin-left-auto margin-bottom-0"
  }, "".concat(svs.utils.format.Currency(game.maxWin), " kr"))))), game.imageOverlay && React.createElement("div", {
    className: "einstant-ticket-card-image-overlay"
  }, React.createElement(ImageMemo, {
    fitWrapper: true,
    image: game.imageOverlay,
    loadingLazy: true
  })))));
};
setGlobal('svs.eInstant.components.TicketCard', TicketCard);

 })(window);